import React from 'react';
import styled from '../../../../styled';
import TimerDropdown from './TimerDropdown';
const TimeSelectorGrid = styled.div `
  width: 10rem;
  border-left: 0.0625rem solid ${({ theme }) => theme.colors.INK_200};
`;
const RangeGridContainer = styled.div `
  display: flex;
`;
const TimerSelector = ({ value, onTimeChange }) => {
    return (React.createElement(RangeGridContainer, null,
        React.createElement(TimeSelectorGrid, null,
            React.createElement(TimerDropdown, { value: value, onSelect: onTimeChange }))));
};
export default TimerSelector;
//# sourceMappingURL=index.js.map